<template>
  <el-dialog
    :title="'绑定 Telegram 群组 - ' + nickname"
    :visible="visible"
    width="720px"
    :destroy-on-close="true"
    :lock-scroll="false"
    @update:visible="updateVisible">
    <el-form size="mini" label-width="82px" class="ele-form-detail">
      <el-form-item label="当前群组:">
        <span class="ele-text-secondary">{{ currentGroupId || '未绑定' }}</span>
      </el-form-item>
    </el-form>
    <ele-pro-table
      ref="table"
      :datasource="chatList"
      :columns="columns"
      :selection.sync="selection"
      :loading="loading"
      :need-page="false"
      :toolkit="[]"
      height="320"
      tool-class="ele-toolbar-actions">
      <template slot="toolbar">
        <el-button
          size="small"
          type="primary"
          icon="el-icon-refresh"
          class="ele-btn-icon"
          :loading="loading"
          @click="loadChats">
          刷新
        </el-button>
        <el-button
          v-if="currentGroupId"
          size="small"
          type="danger"
          class="ele-btn-icon"
          @click="unbind">
          解除绑定
        </el-button>
        <el-button
          size="small"
          type="warning"
          class="ele-btn-icon"
          :disabled="!selection.length"
          @click="leaveChat">
          退群
        </el-button>
      </template>
      <template slot="title" slot-scope="{ row }">
        {{ row.title }}
      </template>
      <template slot="chat_type" slot-scope="{ row }">
        <dict-tag dict-code="tg_chat_type" :value="row.chat_type" />
      </template>
    </ele-pro-table>
    <div slot="footer">
      <el-button @click="updateVisible(false)">取消</el-button>
      <el-button type="primary" :loading="binding" :disabled="!selection.length" @click="bind">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'AcceptorBindDialog',
  props: {
    visible: Boolean,
    acceptor: Object
  },
  data() {
    return {
      loading: false,
      binding: false,
      chatList: [],
      selection: [],
      currentGroupId: '',
      columns: [
        {
          columnKey: 'selection',
          type: 'selection',
          width: 45,
          align: 'center'
        },
        {
          prop: 'title',
          label: '群组名称',
          minWidth: 180,
          align: 'center',
          showOverflowTooltip: true,
          slot: 'title'
        },
        {
          prop: 'chat_id',
          label: '群组ID',
          minWidth: 140,
          align: 'center',
          showOverflowTooltip: true
        },
        {
          prop: 'chat_type',
          label: '类型',
          width: 100,
          align: 'center',
          slot: 'chat_type'
        }
      ]
    };
  },
  computed: {
    nickname() {
      if (!this.acceptor) {
        return '';
      }
      return this.acceptor.bot_group_name
        || this.acceptor.bot_group_id
        || (this.acceptor.id ? '#' + this.acceptor.id : '');
    }
  },
  watch: {
    visible(val) {
      if (!val) {
        this.chatList = [];
        this.selection = [];
        return;
      }
      this.currentGroupId = this.acceptor && this.acceptor.bot_group_id;
      this.selection = [];
      this.loadChats();
    }
  },
  methods: {
    updateVisible(value) {
      this.$emit('update:visible', value);
    },
    loadChats() {
      this.loading = true;
      this.$http
        .get('/acceptor/botChatList')
        .then((res) => {
          this.loading = false;
          if (res.data.code === 0) {
            this.chatList = res.data.data || [];
            this.selection = [];
            return;
          }
          this.$message.error(res.data.msg || '获取群组失败');
        })
        .catch((e) => {
          this.loading = false;
          this.$message.error(e.message);
        });
    },
    bind() {
      if (!this.acceptor || !this.acceptor.id) {
        this.$message.warning('承兑信息无效');
        return;
      }
      if (!this.selection.length) {
        this.$message.warning('请选择');
        return;
      }
      if (this.selection.length > 1) {
        this.$message.warning('一次只能绑定一个群组');
        return;
      }
      const chatId = this.selection[0].chat_id;
      this.binding = true;
      this.$http
        .post('/acceptor/bindBotGroup', {
          id: this.acceptor.id,
          chat_id: chatId
        })
        .then((res) => {
          this.binding = false;
          if (res.data.code === 0) {
            this.$message.success(res.data.msg || '绑定成功');
            this.$emit('done');
            this.updateVisible(false);
            return;
          }
          this.$message.error(res.data.msg || '绑定失败');
        })
        .catch((e) => {
          this.binding = false;
          this.$message.error(e.message);
        });
    },
    unbind() {
      if (!this.acceptor || !this.acceptor.id) {
        return;
      }
      this.$confirm('确定解除该承兑的群组绑定吗?', '提示', { type: 'warning' })
        .then(() => {
          const loading = this.$loading({ lock: true });
          this.$http
            .post('/acceptor/unbindBotGroup', { id: this.acceptor.id })
            .then((res) => {
              loading.close();
              if (res.data.code === 0) {
                this.$message.success(res.data.msg || '已解除绑定');
                this.currentGroupId = '';
                this.loadChats();
                this.$emit('done');
                return;
              }
              this.$message.error(res.data.msg || '解绑失败');
            })
            .catch((e) => {
              loading.close();
              this.$message.error(e.message);
            });
        })
        .catch(() => {});
    },
    leaveChat() {
      if (!this.selection.length) {
        this.$message.warning('请选择');
        return;
      }
      if (this.selection.length > 1) {
        this.$message.warning('一次只能退出一个群组');
        return;
      }
      const chatId = this.selection[0].chat_id;
      this.$confirm('确定退出该群组吗?', '提示', { type: 'warning' })
        .then(() => {
          const loading = this.$loading({ lock: true });
          this.$http
            .post('/acceptor/leaveBotChat', { chat_id: chatId })
            .then((res) => {
              loading.close();
              if (res.data.code === 0) {
                this.$message.success(res.data.msg || '已退出群组');
                if (String(this.currentGroupId) === String(chatId)) {
                  this.currentGroupId = '';
                }
                this.loadChats();
                this.$emit('done');
                return;
              }
              this.$message.error(res.data.msg || '退群失败');
            })
            .catch((e) => {
              loading.close();
              this.$message.error(e.message);
            });
        })
        .catch(() => {});
    }
  }
};
</script>
